<template>
  <div>
    <user-intent-node-component
      v-if="nodeCfg.type === 'userIntentNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="updateUserIntentionData"
    />
    <info-extract-node-component
      v-if="nodeCfg.type === 'infoExtractNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="updateInfoExtractData"
    />
    <condition-judge-node-component
      v-if="nodeCfg.type === 'conditionJudgeNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="updateConditionJudgeData"
    />
    <agent-interface-call-node-component
      v-if="nodeCfg.type === 'interfaceInvocationNode'"
      :key="modelData.id"
      :data="formData"
      :current-node-id="modelData.id"
      @updateData="updateInterfaceCallData"
    />
    <end-reply-node-component
      v-if="nodeCfg.type === 'endReplyNode'"
      :key="modelData.id"
      :data="formData"
      @updateData="updateEndReplyData"
    />
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  nodeCfg: any;
  modelData: any;
  formData: any;
  visible: boolean;
}>();

const emit = defineEmits(["update:formData"]);

const updateUserIntentionData = (data: any) => {
  emit("update:formData", { type: "userIntention", data });
};

const updateInfoExtractData = (data: any) => {
  emit("update:formData", { type: "infoExtract", data });
};

const updateConditionJudgeData = (data: any) => {
  emit("update:formData", { type: "conditionJudge", data });
};

const updateInterfaceCallData = (data: any) => {
  emit("update:formData", { type: "interface", data });
};

const updateEndReplyData = (data: any) => {
  emit("update:formData", { type: "endReply", data });
};
</script>
